<template>
  <section style="width: 500px">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <form action v-on:submit.prevent="login">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p>Su sesión ha expirado, por favor ingresar nuevamente sus credenciales</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Correo Electrónico">
            <b-input
              type="email"
              v-model="email"
              placeholder="Correo Electrónico"
              required
            ></b-input>
          </b-field>
          <b-field label="Contraseña">
            <b-input
              type="password"
              v-model="password"
              placeholder="Contraseña"
              required
            ></b-input>
          </b-field>
          <div class="field">
            <b-message type="is-danger" v-if="error">
            {{error}}
            </b-message>
            <!-- <label class="checkbox"></label> -->
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" type="submit">Ingresar</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
// import { getRole } from "@/services/role";
export default {
  data() {
    return {
      isLoading: false,
      email: "",
      password: "",
      grant_type: "password",
      error: "",
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.$http
        .post("api/auth", {
          email: this.email,
          password: this.password,
          grant_type: this.grant_type,
          node_id: window.localStorage.getItem("stablishment"),
          role_id: window.localStorage.getItem("role_id")
        })
        .then(async (response) => {
          let token = response.body.token;
          window.localStorage.setItem(
            "token",
            token
          );
          window.localStorage.setItem("userName",
          `${response.body.user.name} ${response.body.user.apepat} ${response.body.user.apemat}`
          );
          // let role = await getRole(this.$http, this.user.role_id);
          window.localStorage.setItem("perfil",  window.localStorage.getItem("perfil"));
          // window.localStorage.setItem("perfil",response.body.user.role.type);
          window.localStorage.setItem("user",JSON.stringify(response.data.user));
          window.location.reload();
        })
        .catch((response) => {
          this.isLoading = false;
          this.error="Usuario y/o contraseña incorrecta";
          console.error(response);
        });
    }
  },
};
</script>